import axios from 'axios';
import { REFUNDS, OLD_REFUNDS } from './constants';

export function postRefund(data) {
  return axios
    .post(
      REFUNDS,
      { refund: data.refund },
      {
        headers: { OUTLET_ID: data.outletId },
        withCredentials: true,
      }
    )
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

export function postOldRefund(data) {
  return axios
    .post(
      OLD_REFUNDS,
      { refund: data.refund },
      {
        headers: { OUTLET_ID: data.outletId },
        withCredentials: true,
      }
    )
    .catch(error => {
      let reject;
      if (error.response) {
        reject = new Error(error.response.data.error);
      } else {
        reject = new Error(error.message);
      }
      return Promise.reject(reject);
    });
}
